export default function () {
  return {
    current: {
      id: '',
      name: '',
      backups: [
        {
          date: '',
          file: '',
          size: '',
          key: ''
        }
      ]
    },
    systemList: [],
    clientList: []
  }
}
